'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerDescription = renderWithRef('BannerDescription', null, (n, o)=>{
    let { children: t } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-banner-description'
        ],
        props: n,
        children: t
    });
});

export { BannerDescription };
